import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { routes } from '../../MainPage'
import { getWindowDimensions } from './Footer'
function Header(props) {
  let navigate = useNavigate();
  const [DiesaseOpen, setDiesaseOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleNavigation = (path) => {
    document.body.classList.remove('navShowed')
    navigate(path)
  }
  var DiesaseArr = [
    { name: routes.allergic, lable: 'Allergic Rhinitis', },
    { name: routes.AnalFissure, lable: 'Anal fissure' },
    { name: routes.anemia, lable: 'Anemia', },
    { name: routes.anorexiaNervosa, lable: 'Anorexia nervosa', },
    { name: routes.dyspnea, lable: 'Dyspnea', },
    { name: routes.hepatitis, lable: 'Hepatitis', },
    { name: routes.cancer, lable: 'Cancer', },
    { name: routes.autism, lable: 'Autism', },
    { name: routes.chickenpox, lable: 'Chickenpox', },
    { name: routes.deafness, lable: 'Deafness', },
    { name: routes.piles, lable: 'Piles', },
    { name: routes.BulimiaNervosa, lable: 'Bulimia Nervosa', },
    { name: routes.Measle, lable: 'Measle' },
    { name: routes.Mumps, lable: 'Mumps(parotitis)' },
    { name: routes.SystemicLupusErythematosus, lable: 'Systemic lupus erythematosus' },
    { name: routes.PlicaPolonica, lable: 'Plica polonica(Polish plait)' },
    { name: routes.CrohnDisease, lable: "Crohn's Disease" },
    { name: routes.Hypercholesterolemia, lable: 'High cholesterol (hypercholesterolemia)' },
    { name: routes.ChronicObstructivePulmonary, lable: 'Chronic obstructive pulmonary' },
    { name: routes.Croup, lable: 'Croup' },
    { name: routes.Pleurisy, lable: 'Pleurisy' },
    { name: routes.CommonCold, lable: 'Common Cold' },
    { name: routes.Onycomycosis, lable: 'Onycomycosis' },
    { name: routes.Paronychia, lable: 'Paronychia' },
    { name: routes.Hyperhydrosis, lable: 'Hyperhydrosis' },
    { name: routes.Epistexis, lable: 'Epistexis' },
    { name: routes.Sunburn, lable: 'Sunburn' },
    { name: routes.Chilblains, lable: 'Chilblains' },
    { name: routes.VaricoseVein, lable: 'Varicose Vein' },
    { name: routes.Gingivitis, lable: 'Gingivitis' },
    { name: routes.Cholera, lable: 'Cholera' },
    { name: routes.Gangren, lable: "Gangren" },
    { name: routes.NeurogenicBladder, lable: 'Neurogenic Bladder' },
    { name: routes.UrinaryIncontinence, lable: 'Urinary Incontinence' },
    { name: routes.Cystocele, lable: "Cystocele (bladder hernia)" },
    { name: routes.TenisElbow, lable: 'Tenis elbow(lateral epicondylitis)' },
    { name: routes.StudentElbow, lable: "Student elbow (Olecranon Bursitis)" },
    { name: routes.Toothache, lable: 'Toothache' },
    { name: routes.TrigeminalNeuralgia, lable: 'Trigeminal Neuralgia(tic douloureux)' },
    { name: routes.Wounds, lable: 'Wounds' },
    { name: routes.Appendix, lable: "Appendix" },
    { name: routes.WritersCramp, lable: "Writer’s cramp" },
    { name: routes.Trauma, lable: 'Trauma' },
    { name: routes.DiabeticFoot, lable: 'Diabetic foot' },
    { name: routes.NonHealingUlcer, lable: "Non healing ulcer" },
    { name: routes.NonUnionOfBone, lable: "Non union of bone" },
    { name: routes.Dyslexia, lable: "Dyslexia" },
    { name: routes.IdiopathicThrombocytopenicPurpura, lable: 'Idiopathic Thrombocytopenic Purpura' },
    { name: routes.Dermatitis, lable: 'Dermatitis' },
    { name: routes.Menieres, lable: "Meniere's disease" },
    { name: routes.PuerperalPsychosis, lable: 'Puerperal psychosis ( puerperal psychosis)' }
  ]
  DiesaseArr.sort((a, b) => (a.lable > b.lable) ? 1 : ((b.lable > a.lable) ? -1 : 0))


  return (
    <>
      <div className="radial-bg" />
      <header>
        <div className="container headerBox">
          <div className="navIcon flex-50 visible-lg" onClick={() => {
            setDiesaseOpen(false);
            setIsMenuOpen(!isMenuOpen)
            if (document.body.classList.contains("navShowed")) {
              // I have the 'hidden' class
              document.body.classList.remove('navShowed')
            } else {
              document.body.classList.add('navShowed')
            }

          }}>
            <div className="navIcon-i">
              <span className="line" />
              <span className="line" />
              <span className="line" />
            </div>
          </div>
          <div className="navLogo">
            <a href={routes.home} className="logoLink navMainLink" onClick={() => handleNavigation(routes.home)}>

              <img src={require('../../img/logo.png')} alt="logo" />

            </a>
          </div>
          <div className="navLeft">
            <div className="sidebar-title visible-lg">
              <h3>MENU</h3>
              <a className="close-menu" href="javascript:void(0)" onClick={() => { setDiesaseOpen(false); document.body.classList.remove('navShowed'); setIsMenuOpen(!isMenuOpen); }} >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 327.08 327.06">
                  <path d="M.51,11.4C3.07.66,14.86-3.15,23.13,4.1c.88.77,1.68,1.63,2.5,2.46Q93.39,74.29,161.06,142.07c2.07,2.07,3,1.8,4.84-.08Q234,73.72,302.25,5.59C308.09-.25,314-1.5,320,1.78a13.43,13.43,0,0,1,4.29,20,38.33,38.33,0,0,1-3.46,3.75Q253,93.4,185.09,161.19C183.2,163.08,183,164,185,166q68.19,68,136.24,136c4.16,4.15,6.49,8.79,5,14.59a12.8,12.8,0,0,1-10.54,9.87c-1.48.58-3.13-.29-4.58.52h-.64c-4-.62-6.9-2.92-9.66-5.68q-66.78-66.84-133.62-133.63c-.68-.68-1.38-1.33-2-2-1.1-1.19-2.14-1.21-3.25,0-.65.7-1.35,1.35-2,2l-133,132.94c-2.94,2.94-6,5.74-10.33,6.38H10.86Q1.5,325.56,0,316.2v-5.75c.64-4.36,3.44-7.39,6.38-10.33Q72.17,234.34,138,168.55c5.77-5.78,5.84-4.18,0-10Q71.85,92.38,5.71,26.28C2.83,23.39,0,20.47.33,15.9.42,14.4.13,12.88.51,11.4Z" />
                </svg>
              </a>
            </div>
            <div className="navMenu">
              <ul className="navMenuUl navUl list-inline">
                <li className="navLi">
                  <a onClick={() => handleNavigation(routes.home)}
                    href={routes.home}
                    className="navLink navMainLink notLevels"
                  >
                    Home
                  </a>
                </li>
                <li className="navLi">
                  <a
                    onClick={() => handleNavigation(routes.about)}
                    href={routes.about}
                    className="navLink navMainLink notLevels"
                  >
                    About
                  </a>
                </li>
                <li className="navLi sub_menu_li" 
                //  onMouseOver={() => setDiesaseOpen(true)}
                //     onMouseLeave={() => { setDiesaseOpen(false) }}
                    >
                  <a
                    
                    href={routes.disease}
                    className="navLink navMainLink hidden-lg"
                  >
                    Disease
                    <i className="fas fa-plus" />
                  </a>

                  <a onClick={() => {setDiesaseOpen(!DiesaseOpen)}}
                    href='javascript:void(0)'
                    className={`navLink navMainLink visible-lg sub_levels ${DiesaseOpen ? "showed" : ''}`}
                  >
                    Disease
                    <i className="fas fa-plus" />
                  </a>

                  <ul className={`sub-menu ${DiesaseOpen ? "is-active" : ''}`}
                  style={{ "display": getWindowDimensions().width > 1200 ? 'block' : DiesaseOpen ? 'block' : 'none' }}
                  >
                    <li className="add-menu-left">
                      <ul className="listUnstyle">
                        {DiesaseArr.map((item) => (
                          <li key={item.name}>
                            <a href={item.name}>
                              <span>{item.lable}</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </li>
                <li className="navLi">
                  <a
                    onClick={() => handleNavigation(routes.team)}
                    href={routes.team}

                    className="navLink navMainLink notLevels"
                  >
                    Team
                  </a>
                </li>
                <li className="navLi">
                  <a
                    onClick={() => handleNavigation(routes.blog)}
                    href={routes.blog}
                    className="navLink navMainLink notLevels"
                  >
                    R&D
                  </a>
                </li>
                <li className="navLi">
                  <a
                    onClick={() => handleNavigation(routes.HFC)}
                    href={routes.HFC}
                    className="navLink navMainLink notLevels"
                  >
                    HFC
                  </a>
                </li>
                <li className="navLi">
                  <a
                    onClick={() => handleNavigation(routes.contact)}
                    href={routes.contact}
                    className="navLink navMainLink notLevels"
                  >
                    Contact us
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="navRight">
            <div className="navRightMenu">
              <ul className="rightUl list-inline">
                <li className="rightLi">
                  <a
                    href={routes.makeAppointmnet}
                    className="btn btn-uppercase"
                    onClick={() => handleNavigation(routes.makeAppointmnet)}
                  >
                    <span className="hidden-xs">Online Consulting</span>
                    <span className="visible-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="m14.13 60h25a5.50972 5.50972 0 0 0 5.5-5.5v-7.5h-33v-37.5a2.50091 2.50091 0 0 1 2.5-2.5h25a2.50091 2.50091 0 0 1 2.5 2.5v6.5h3v-6.5a5.50972 5.50972 0 0 0 -5.5-5.5h-25a5.50968 5.50968 0 0 0 -5.5 5.5v45a5.50968 5.50968 0 0 0 5.5 5.5zm-2.5-10h30v4.5a2.50091 2.50091 0 0 1 -2.5 2.5h-25a2.50091 2.50091 0 0 1 -2.5-2.5z"
                        />
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="m18.629 10.537h16v3h-16z"
                        />
                        <circle
                          xmlns="http://www.w3.org/2000/svg"
                          cx="26.129"
                          cy="53.5"
                          r="1.5"
                        />
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="m49.08 31.41v3.99a5.50332 5.50332 0 0 1 -5.5 5.5h-7.41a5.51164 5.51164 0 0 1 -5.5-5.38 9.32874 9.32874 0 0 0 7.81-9.18v-6.12a1.498 1.498 0 0 0 -1.5-1.5h-2.77v-1.67h-3v6.35h3v-1.68h1.27v4.62a6.31 6.31 0 0 1 -12.62 0v-4.62h1.27v1.68h3v-6.35h-3v1.67h-2.77a1.498 1.498 0 0 0 -1.5 1.5v6.12a9.32092 9.32092 0 0 0 7.81 9.18 8.51344 8.51344 0 0 0 8.5 8.38h7.41a8.50566 8.50566 0 0 0 8.5-8.5v-3.99a4.50006 4.50006 0 1 0 -3 0zm1.5-5.72a1.5 1.5 0 1 1 -1.5 1.5 1.498 1.498 0 0 1 1.5-1.5z"
                        />
                      </svg>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={`c-mask visible-lg ${isMenuOpen ? "show-mask" : ''}`} onClick={() => { setDiesaseOpen(false); document.body.classList.remove('navShowed'); setIsMenuOpen(!isMenuOpen) }} />
        </div>
      </header>
    </>
  );
}

export default Header;